import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "src/contexts/AppContext";
import * as Constants from "../../core/Constants/Constants";
import { findQuestionInService, resolveContactPerson } from "src/utils";

export default function PayrollAndExpenseAndTravelInvoiceManagementSummaryPanel(): JSX.Element {
  const { t } = useTranslation();
  const { globalState } = useContext(AppContext);

  const service = globalState.services.find(
    (item) =>
      item.data.code ===
      Constants.ServiceCode.PayrollAndExpenseAndTravelInvoiceManagement
  );

  const contactPersonQuestion = findQuestionInService(
    service,
    Constants.PayrollAndExpenseAndTravelInvoiceManagementQuestions.Q0763
  );
  const contactPerson = resolveContactPerson(
    contactPersonQuestion?.data?.options?.find(
      (item) => item.key === contactPersonQuestion.data.userValue
    )?.value
  );

  const nrOfPayslips = findQuestionInService(
    service,
    Constants.PayrollAndExpenseAndTravelInvoiceManagementQuestions.Q0701
  )?.data?.userValue;

  return (
    <article className="gt-summaryPanel">
      <div className="gt-summaryPanel__contactPerson">
        {t("PanelHeader.ContactPersonClientText", { contactPerson })}
      </div>
      <div className="gt-summaryPanel__data">
        {t("PanelHeader.NrOfPayslips", { nrOfPayslips })}
      </div>{" "}
    </article>
  );
}
